module.exports = __webpack_public_path__ + "static/assets/2051a4bfde3e5a54acea63dec78e1d1e.svg";